export default __webpack_public_path__ + "static/it-map-869173fabc807a06dccbc48cccd054fd.png";